export default class Component {
    constructor(page, definition, el, options = {}) {
        Object.assign(this, definition);

        this.app = page.app;
        this.context = window.document;
        this.el = el;
        this.options = options;
        this.page = page;
        this.init(options);
    }

    init(options) {
        // To override...
    }
}
